export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-megaphone-6a9eaff578bbc89392586ade44a56eee.svg";